import { ref, onMounted, onUnmounted, computed } from 'vue';

const MOBILE_BREAKPOINT = 768; // Tailwind `md`

const width = ref(typeof window !== 'undefined' ? window.innerWidth : 1024);

let listenerCount = 0;
const onResize = () => {
  width.value = window.innerWidth;
};

export const useIsMobile = () => {
  onMounted(() => {
    if (listenerCount === 0) {
      window.addEventListener('resize', onResize);
    }
    listenerCount++;
    width.value = window.innerWidth;
  });

  onUnmounted(() => {
    listenerCount--;
    if (listenerCount === 0) {
      window.removeEventListener('resize', onResize);
    }
  });

  return {
    screenWidth: width,
    isMobile: computed(() => width.value < MOBILE_BREAKPOINT),
  };
};
